import {Auth} from 'aws-amplify'
import axios from 'axios'

export default {
  mounted() {},
  methods: {
    // Download a invoice PDF is deprecated.
    // async getInvoice(itemId) {
    //   try {
    //     const result = await axios.get(
    //       process.env.VUE_APP_API_ENDPOINT + '/subscription/invoices/' + itemId,
    //       {
    //         headers: {
    //           Authorization: (await Auth.currentSession()).getIdToken()
    //             .jwtToken,
    //         },
    //       }
    //     )
    //     return result
    //   } catch (error) {
    //     alert(this.getCommonErrorMessage(error))
    //     return false
    //   }
    // },
    async getInvoices() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/invoices',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getPlans() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/resources/subscription_plans'
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getTokenPlans() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/resources/token_plans'
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getMyPlan() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/myplan',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getSetupIntentsSecret() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT +
            '/subscription/setup_intents_secret',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async getTeam() {
      try {
        const result = await axios.get(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/team',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async postMyPlan(plan) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/myplan',
          {
            PlanName: plan,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async postToken(tokens) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/tokens',
          {
            NumTokens: tokens,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async postTeam(team) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/team',
          {
            TeamName: team,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async postTeamMember(email) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/team/users',
          {
            Email: email,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        const alertMsgs = [
          'The maximum number of members in a team is 50',
          'User already in the team',
          'Only free user can be added to a team',
        ]
        if (
          error.response &&
          error.response.data &&
          error.response.data.Message
        ) {
          let displayMsg = ''
          for (const msg of alertMsgs) {
            if (error.response.data.Message.indexOf(msg) > -1) {
              displayMsg = msg
            }
          }
          if (displayMsg) {
            alert(displayMsg)
          } else {
            alert(this.getCommonErrorMessage(error))
          }
        } else {
          alert(this.getCommonErrorMessage(error))
        }
        return false
      }
    },
    async postSubscriptionPayment(paymentMethodId) {
      try {
        const result = await axios.post(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/payment',
          {
            PaymentMethodId: paymentMethodId,
          },
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        if (error && error.response) {
          return error.response
        } else {
          alert(this.getCommonErrorMessage(error))
          return false
        }
      }
    },
    async deleteTeam() {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/team',
          {
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
    async deleteTeamMember(email) {
      try {
        const result = await axios.delete(
          process.env.VUE_APP_API_ENDPOINT + '/subscription/team/users',
          {
            params: {
              email: email,
            },
            headers: {
              Authorization: (await Auth.currentSession()).getIdToken()
                .jwtToken,
            },
          }
        )
        return result
      } catch (error) {
        alert(this.getCommonErrorMessage(error))
        return false
      }
    },
  },
}
